import axios from "axios";
import { BASE_API_URL, BASE_URL } from '../../../../../../../Constants';

export default axios.create({
    baseURL: BASE_API_URL,
    headers: {
		"Content-type": "multipart/form-data"
    }
})
